
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const TeamUserRole = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  VIEWER: 'VIEWER',
  CUSTOM: 'CUSTOM'
} as const

export type TeamUserRole = (typeof TeamUserRole)[keyof typeof TeamUserRole]


export const RoleBindingScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type RoleBindingScopeType = (typeof RoleBindingScopeType)[keyof typeof RoleBindingScopeType]


export const GrantScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT',
  RESOURCE: 'RESOURCE',
  PLATFORM: 'PLATFORM'
} as const

export type GrantScopeType = (typeof GrantScopeType)[keyof typeof GrantScopeType]


export const GrantPrincipalType = {
  USER: 'USER',
  API_KEY: 'API_KEY',
  GROUP: 'GROUP',
  TEAM: 'TEAM',
  ORGANIZATION: 'ORGANIZATION',
  PROJECT: 'PROJECT',
  ANYONE: 'ANYONE'
} as const

export type GrantPrincipalType = (typeof GrantPrincipalType)[keyof typeof GrantPrincipalType]


export const OrganizationUserRole = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  EXTERNAL: 'EXTERNAL'
} as const

export type OrganizationUserRole = (typeof OrganizationUserRole)[keyof typeof OrganizationUserRole]


export const PlanTypes = {
  FREE: 'FREE',
  PRO: 'PRO',
  GROWTH: 'GROWTH',
  GROWTH_SEAT_EUR_MONTHLY: 'GROWTH_SEAT_EUR_MONTHLY',
  GROWTH_SEAT_EUR_ANNUAL: 'GROWTH_SEAT_EUR_ANNUAL',
  GROWTH_SEAT_USD_MONTHLY: 'GROWTH_SEAT_USD_MONTHLY',
  GROWTH_SEAT_USD_ANNUAL: 'GROWTH_SEAT_USD_ANNUAL',
  ENTERPRISE: 'ENTERPRISE',
  LAUNCH: 'LAUNCH',
  ACCELERATE: 'ACCELERATE',
  LAUNCH_ANNUAL: 'LAUNCH_ANNUAL',
  ACCELERATE_ANNUAL: 'ACCELERATE_ANNUAL'
} as const

export type PlanTypes = (typeof PlanTypes)[keyof typeof PlanTypes]


export const PricingModel = {
  TIERED: 'TIERED',
  SEAT_EVENT: 'SEAT_EVENT'
} as const

export type PricingModel = (typeof PricingModel)[keyof typeof PricingModel]


export const OrganizationIntent = {
  AGENT_GOVERNANCE: 'AGENT_GOVERNANCE',
  LLM_OPS: 'LLM_OPS'
} as const

export type OrganizationIntent = (typeof OrganizationIntent)[keyof typeof OrganizationIntent]


export const SubscriptionStatus = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED'
} as const

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]


export const Currency = {
  USD: 'USD',
  EUR: 'EUR'
} as const

export type Currency = (typeof Currency)[keyof typeof Currency]


export const INVITE_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  REVOKED: 'REVOKED'
} as const

export type INVITE_STATUS = (typeof INVITE_STATUS)[keyof typeof INVITE_STATUS]


export const EvaluationExecutionMode = {
  ON_MESSAGE: 'ON_MESSAGE',
  AS_GUARDRAIL: 'AS_GUARDRAIL',
  MANUALLY: 'MANUALLY'
} as const

export type EvaluationExecutionMode = (typeof EvaluationExecutionMode)[keyof typeof EvaluationExecutionMode]


export const CostType = {
  TRACE_CHECK: 'TRACE_CHECK',
  GUARDRAIL: 'GUARDRAIL',
  CLUSTERING: 'CLUSTERING',
  BATCH_EVALUATION: 'BATCH_EVALUATION'
} as const

export type CostType = (typeof CostType)[keyof typeof CostType]


export const CostReferenceType = {
  CHECK: 'CHECK',
  TRACE: 'TRACE',
  PROJECT: 'PROJECT',
  BATCH: 'BATCH'
} as const

export type CostReferenceType = (typeof CostReferenceType)[keyof typeof CostReferenceType]


export const TriggerAction = {
  SEND_EMAIL: 'SEND_EMAIL',
  ADD_TO_DATASET: 'ADD_TO_DATASET',
  ADD_TO_ANNOTATION_QUEUE: 'ADD_TO_ANNOTATION_QUEUE',
  SEND_SLACK_MESSAGE: 'SEND_SLACK_MESSAGE',
  SEND_WEBHOOK: 'SEND_WEBHOOK'
} as const

export type TriggerAction = (typeof TriggerAction)[keyof typeof TriggerAction]


export const TriggerKind = {
  AUTOMATION: 'AUTOMATION',
  ALERT: 'ALERT',
  REPORT: 'REPORT'
} as const

export type TriggerKind = (typeof TriggerKind)[keyof typeof TriggerKind]


export const AlertType = {
  CRITICAL: 'CRITICAL',
  WARNING: 'WARNING',
  INFO: 'INFO'
} as const

export type AlertType = (typeof AlertType)[keyof typeof AlertType]


export const WebhookDeliveryOutcome = {
  success: 'success',
  retryable: 'retryable',
  terminal: 'terminal',
  pending: 'pending'
} as const

export type WebhookDeliveryOutcome = (typeof WebhookDeliveryOutcome)[keyof typeof WebhookDeliveryOutcome]


export const WebhookDestinationKind = {
  http: 'http',
  sqs: 'sqs'
} as const

export type WebhookDestinationKind = (typeof WebhookDestinationKind)[keyof typeof WebhookDestinationKind]


export const WebhookEndpointStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED'
} as const

export type WebhookEndpointStatus = (typeof WebhookEndpointStatus)[keyof typeof WebhookEndpointStatus]


export const WebhookDeliveryChannel = {
  platform: 'platform',
  automations: 'automations'
} as const

export type WebhookDeliveryChannel = (typeof WebhookDeliveryChannel)[keyof typeof WebhookDeliveryChannel]


export const ExperimentType = {
  DSPY: 'DSPY',
  BATCH_EVALUATION: 'BATCH_EVALUATION',
  BATCH_EVALUATION_V2: 'BATCH_EVALUATION_V2',
  EVALUATIONS_V3: 'EVALUATIONS_V3'
} as const

export type ExperimentType = (typeof ExperimentType)[keyof typeof ExperimentType]


export const ModelProviderScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type ModelProviderScopeType = (typeof ModelProviderScopeType)[keyof typeof ModelProviderScopeType]


export const ModelDefaultScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type ModelDefaultScopeType = (typeof ModelDefaultScopeType)[keyof typeof ModelDefaultScopeType]


export const LangyProjectionTitleSource = {
  derived: 'derived',
  auto: 'auto',
  user: 'user'
} as const

export type LangyProjectionTitleSource = (typeof LangyProjectionTitleSource)[keyof typeof LangyProjectionTitleSource]


export const AnnotationScoreDataType = {
  CATEGORICAL: 'CATEGORICAL',
  BOOLEAN: 'BOOLEAN',
  LIKERT: 'LIKERT',
  OPTION: 'OPTION',
  CHECKBOX: 'CHECKBOX'
} as const

export type AnnotationScoreDataType = (typeof AnnotationScoreDataType)[keyof typeof AnnotationScoreDataType]


export const ShareResourceType = {
  TRACE: 'TRACE',
  THREAD: 'THREAD'
} as const

export type ShareResourceType = (typeof ShareResourceType)[keyof typeof ShareResourceType]


export const ShareVisibility = {
  PUBLIC: 'PUBLIC',
  ORGANIZATION: 'ORGANIZATION',
  PROJECT: 'PROJECT'
} as const

export type ShareVisibility = (typeof ShareVisibility)[keyof typeof ShareVisibility]


export const PinSource = {
  manual: 'manual',
  share: 'share'
} as const

export type PinSource = (typeof PinSource)[keyof typeof PinSource]


export const RetentionPolicyScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type RetentionPolicyScopeType = (typeof RetentionPolicyScopeType)[keyof typeof RetentionPolicyScopeType]


export const DataPrivacyScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  DEPARTMENT: 'DEPARTMENT',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type DataPrivacyScopeType = (typeof DataPrivacyScopeType)[keyof typeof DataPrivacyScopeType]


export const CustomLLMModelCostScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type CustomLLMModelCostScopeType = (typeof CustomLLMModelCostScopeType)[keyof typeof CustomLLMModelCostScopeType]


export const PromptScope = {
  ORGANIZATION: 'ORGANIZATION',
  PROJECT: 'PROJECT'
} as const

export type PromptScope = (typeof PromptScope)[keyof typeof PromptScope]


export const VirtualKeyStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  REVOKED: 'REVOKED'
} as const

export type VirtualKeyStatus = (typeof VirtualKeyStatus)[keyof typeof VirtualKeyStatus]


export const VirtualKeyPurpose = {
  USER: 'USER',
  LANGY: 'LANGY'
} as const

export type VirtualKeyPurpose = (typeof VirtualKeyPurpose)[keyof typeof VirtualKeyPurpose]


export const GatewayProviderRotationPolicy = {
  MANUAL: 'MANUAL'
} as const

export type GatewayProviderRotationPolicy = (typeof GatewayProviderRotationPolicy)[keyof typeof GatewayProviderRotationPolicy]


export const GatewayProviderHealthStatus = {
  UNKNOWN: 'UNKNOWN',
  HEALTHY: 'HEALTHY',
  DEGRADED: 'DEGRADED',
  CIRCUIT_OPEN: 'CIRCUIT_OPEN'
} as const

export type GatewayProviderHealthStatus = (typeof GatewayProviderHealthStatus)[keyof typeof GatewayProviderHealthStatus]


export const GatewayBudgetScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT',
  VIRTUAL_KEY: 'VIRTUAL_KEY',
  PRINCIPAL: 'PRINCIPAL',
  GROUP: 'GROUP',
  ATTRIBUTED_USER: 'ATTRIBUTED_USER'
} as const

export type GatewayBudgetScopeType = (typeof GatewayBudgetScopeType)[keyof typeof GatewayBudgetScopeType]


export const GatewayBudgetWindow = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  TOTAL: 'TOTAL',
  MANUAL: 'MANUAL'
} as const

export type GatewayBudgetWindow = (typeof GatewayBudgetWindow)[keyof typeof GatewayBudgetWindow]


export const GatewayBudgetBreachAction = {
  BLOCK: 'BLOCK',
  WARN: 'WARN'
} as const

export type GatewayBudgetBreachAction = (typeof GatewayBudgetBreachAction)[keyof typeof GatewayBudgetBreachAction]


export const GatewayBudgetLedgerStatus = {
  SUCCESS: 'SUCCESS',
  PROVIDER_ERROR: 'PROVIDER_ERROR',
  BLOCKED_BY_GUARDRAIL: 'BLOCKED_BY_GUARDRAIL',
  CANCELLED: 'CANCELLED'
} as const

export type GatewayBudgetLedgerStatus = (typeof GatewayBudgetLedgerStatus)[keyof typeof GatewayBudgetLedgerStatus]


export const GatewayChangeEventKind = {
  VK_CREATED: 'VK_CREATED',
  VK_CONFIG_UPDATED: 'VK_CONFIG_UPDATED',
  VK_REVOKED: 'VK_REVOKED',
  VK_ROTATED: 'VK_ROTATED',
  VK_DISABLED: 'VK_DISABLED',
  VK_ENABLED: 'VK_ENABLED',
  BUDGET_CREATED: 'BUDGET_CREATED',
  BUDGET_UPDATED: 'BUDGET_UPDATED',
  BUDGET_DELETED: 'BUDGET_DELETED',
  MODEL_PROVIDER_UPDATED: 'MODEL_PROVIDER_UPDATED',
  CACHE_RULE_CREATED: 'CACHE_RULE_CREATED',
  CACHE_RULE_UPDATED: 'CACHE_RULE_UPDATED',
  CACHE_RULE_DELETED: 'CACHE_RULE_DELETED',
  ROUTING_POLICY_UPDATED: 'ROUTING_POLICY_UPDATED',
  ROUTING_POLICY_DELETED: 'ROUTING_POLICY_DELETED'
} as const

export type GatewayChangeEventKind = (typeof GatewayChangeEventKind)[keyof typeof GatewayChangeEventKind]


export const GatewayCacheRuleMode = {
  RESPECT: 'RESPECT',
  FORCE: 'FORCE',
  DISABLE: 'DISABLE'
} as const

export type GatewayCacheRuleMode = (typeof GatewayCacheRuleMode)[keyof typeof GatewayCacheRuleMode]


export const VirtualKeyRoutingMode = {
  NONE: 'NONE',
  FALLBACK_ALL: 'FALLBACK_ALL',
  POLICY: 'POLICY'
} as const

export type VirtualKeyRoutingMode = (typeof VirtualKeyRoutingMode)[keyof typeof VirtualKeyRoutingMode]


export const VirtualKeyScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type VirtualKeyScopeType = (typeof VirtualKeyScopeType)[keyof typeof VirtualKeyScopeType]


export const RoutingPolicyScopeType = {
  ORGANIZATION: 'ORGANIZATION',
  TEAM: 'TEAM',
  PROJECT: 'PROJECT'
} as const

export type RoutingPolicyScopeType = (typeof RoutingPolicyScopeType)[keyof typeof RoutingPolicyScopeType]


export const GatewayGuardrailDirection = {
  PRE: 'PRE',
  POST: 'POST',
  STREAM_CHUNK: 'STREAM_CHUNK'
} as const

export type GatewayGuardrailDirection = (typeof GatewayGuardrailDirection)[keyof typeof GatewayGuardrailDirection]


export const GatewayGuardrailFailureMode = {
  FAIL_OPEN: 'FAIL_OPEN',
  FAIL_CLOSED: 'FAIL_CLOSED'
} as const

export type GatewayGuardrailFailureMode = (typeof GatewayGuardrailFailureMode)[keyof typeof GatewayGuardrailFailureMode]


export const ProcessManagerOutboxStatus = {
  pending: 'pending',
  dispatched: 'dispatched',
  dead: 'dead',
  discarded: 'discarded'
} as const

export type ProcessManagerOutboxStatus = (typeof ProcessManagerOutboxStatus)[keyof typeof ProcessManagerOutboxStatus]


export const ProcessManagerOutboxAttemptOutcome = {
  retry_scheduled: 'retry_scheduled',
  dead: 'dead'
} as const

export type ProcessManagerOutboxAttemptOutcome = (typeof ProcessManagerOutboxAttemptOutcome)[keyof typeof ProcessManagerOutboxAttemptOutcome]


export const GatewayRealtimeSessionStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  FAILED: 'FAILED',
  EXPIRED: 'EXPIRED'
} as const

export type GatewayRealtimeSessionStatus = (typeof GatewayRealtimeSessionStatus)[keyof typeof GatewayRealtimeSessionStatus]
